import React from 'react';
import { useLanguage } from '../../i18n/useLanguage';
import { StaticPage } from '../StaticPage';
import { SignatureSongContentDe } from './signatureSong/SignatureSongContentDe';
import { SignatureSongContentEn } from './signatureSong/SignatureSongContentEn';

export const SignatureSongPage: React.FC = () => {
  const { language } = useLanguage();
  return (
    <StaticPage titleKey="static.signatureSong">
      {language === 'de' ? <SignatureSongContentDe /> : <SignatureSongContentEn />}
    </StaticPage>
  );
};
